import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.substring(1)).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api.post("/auth/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data.user);
        navigate("/", { replace: true });
      })
      .catch((err) => {
        toast.error(err.response?.data?.detail || "Prijava nije uspjela");
        navigate("/login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[#111827]">
      <img src="/cashline-logo-white.png" alt="Cashline" className="h-10 w-auto animate-pulse" />
      <p className="text-sm text-[#94A3B8]">Prijava u tijeku...</p>
    </div>
  );
}
